import Axios from 'axios';

// Get CSRFToken for header in API call to db
Axios.defaults.xsrfCookieName = 'csrftoken';
Axios.defaults.xsrfHeaderName = 'X-CSRFToken';

// API call to divesite that creates PaymentIntent
export function createPaymentIntent(url, payload, callback) {
  Axios({ method: 'POST', url, data: payload })
    .then(({ data }) => { callback(data); })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
      throw new Error('Creating payment intent failed');
    });
}

export async function updatePaymentIntent(url, payload) {
  return Axios({ method: 'PATCH', url, data: payload })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
      throw new Error('Updating payment intent in failed');
    });
}
